export enum CODE_MESSAGE_INFO {
    CODE_MI_INTRARC_CONNEXION   = 'INTRARC_CONNEXION',
    CODE_MI_INTRARC_ACCUEIL     = 'INTRARC_ACCUEIL',
    CODE_MI_TELERC_ACCUEIL      = 'TELERC_ACCUEIL',
}
